<button
  mat-icon-button
  type="button"
  class="theme-toggle-button"
  [matMenuTriggerFor]="themeMenu"
  [matTooltip]="triggerLabel()"
  [attr.aria-label]="triggerLabel()"
>
  <mat-icon aria-hidden="true">{{ triggerIcon() }}</mat-icon>
</button>

<mat-menu #themeMenu="matMenu" class="theme-menu-panel">
  <!--
    `menu` + `menuitemradio` rather than plain menu items: the three options are mutually
    exclusive and exactly one is always chosen, so a screen reader should announce the selected
    state rather than leaving the check mark as a purely visual cue.

    These rows carry NO `aria-label`, deliberately (WCAG 2.5.3 Label in Name, Level A). Each one
    has a visible text label, so its accessible name has to CONTAIN that text — and an `aria-label`
    replaces the accessible name rather than adding to it. An earlier version set it to a longer
    description ("Always use the light theme"), which read well in a screen reader and meant a
    speech-input user who said "Light" activated nothing at all. The name now comes from the
    visible span; the icons beside it are `aria-hidden` so they add nothing to it.

    The TRIGGER button above is the opposite case and keeps its `aria-label`: it renders an icon
    and no text, so without one it would have no accessible name to contain anything.
  -->
  <div class="theme-menu-heading" role="presentation">Appearance</div>
  @for (option of options; track option.value) {
    <button
      mat-menu-item
      type="button"
      role="menuitemradio"
      [attr.aria-checked]="preference() === option.value"
      [class.selected]="preference() === option.value"
      (click)="select(option.value)"
    >
      <mat-icon aria-hidden="true">{{ option.icon }}</mat-icon>
      <span class="theme-option-label">{{ option.label }}</span>
      @if (preference() === option.value) {
        <mat-icon class="theme-option-check" aria-hidden="true">check</mat-icon>
      }
    </button>
  }
</mat-menu>
